import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPage from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";
import { useEffect } from "react";
import Util from "classes/Util";

/**
 * @name CaptureEDEStatementsEnrollmentStatements
 * @returns {React.Component}
 * @description A capture in the "EDE eStatement Enrollment" capture group.
 */
export default function CaptureEDEStatementsEnrollmentStatements(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    }); 

    return <EDEStatementsPage />;
}